import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/About.scss'
import roopa from '../assets/images/roopa.JPG';

class About extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <section className="about-container contents-align">
                    <div className="about-wrapper">
                        <div className="about-content">
                            <h1 className="about-lawshram">About Lawshram</h1>
                            <p className="about-life">Lawshram is the life work of Roopa Prasad Doraswamy, who has over 23 years of legal work experience in both India and overseas.
                            </p>
                        </div>
                        <div className="quick-links">
                            <Link to="/lawshram-works" className="how-laws-works">How Lawshram works</Link>
                            <Link to="/contact-us" className="connect-with-us">Connect with Us</Link>
                        </div>
                    </div>
                    <div className="image-container">
                        <img src={roopa} className="ceo" alt="roopa dooreswamy"/>
                    </div>
                </section>
                <div className="content">
                    <div className="wrapper">
                        <div className="box">
                            <p>Roopa graduated with B.A. L.L.B. (Honours) from the National Law School of India
                                University, Bangalore, India. Further, she has a Juris Doctorate degree from the
                                Northeastern University School of Law, Boston, Massachusetts.
                            </p>

                        </div>
                        <div className="box">
                            <p>Roopa has over 23 years of experience in law and has worked with major MNCs in both India and overseas, including Bingham McCutchen LLP, Infosys Technologies, Wipro Limited, and more. She also co-founded Bangalore-based law firms Narasappa, Doraswamy & Raja (NDR) and Doraswamy Law Chambers (DLC).
                            </p>

                        </div>
                        <div className="box">
                            <p>Roopa has always been highly driven both professionally and in her personal life. As a
                                working mother of two kids, Roopa had to make difficult choices between her family and
                                her work. She chose to quit her dream job when her kids were born and decided to return
                                to work after a period of time. Roopa found that this transition did not come without
                                repercussions. Whenever she took a break, Roopa had to transfer her clients to suitable
                                lawyers, nurture client relationships with the expectation that she will come back and
                                pick up from where she left off, staying abreast of changes and trends in the law
                                practice, and so on.
                            </p>

                        </div>
                        <div className="box">
                            <p>During this transition, Roopa came across many lawyers who faced similar difficulties.
                                She realized that she wanted to control her work hours and wanted a solution that would
                                make the transition easier, for her and other lawyers.</p>

                        </div>
                        <div className="box">
                            <p>Thus was Lawshram born: a platform that provides freedom and networking capabilities for
                                lawyers to practice law in their own time and at their own pace.
                            </p>

                        </div>
                        <div className="box">
                            <p>Lawshram enables lawyers to build their virtual practice online, define their work hours
                                and workplace, delegate work to fellow lawyers, and much more. Lawshram also makes it
                                easy for lawyers to stay cognizant of current trends and topics in law by providing them
                                access to a huge law database of knowledge and information.
                            </p>
                        </div>
                        <div className="box quick-links">
                            <Link to="/lawshram-works" className="how-laws-works">How Lawshram works</Link>
                            <Link to="/contact-us" className="connect-with-us">Connect with Us</Link>
                        </div>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}

export default About;